import { ReactComponent as IconChevronDown } from '@/assets/svgs/profile-chevron.svg'
import rem from '@/utils/rem'
import classname from 'classnames'
import React, { useCallback, useRef, useState, useEffect } from "react"
import { Manager, Popper, Reference } from "react-popper"
import MultiClamp from 'react-multi-clamp'
import clickCheck from '@/utils/click-check'


const Dropdown = ({ text, addClass, value, options = [], error, submit, width, maxWidth, ghost, full, id, disabled, ...inputProps }) => {
	const [open, setOpen] = useState(false)
	const [label, setLabel] = useState(text)
	const listRef = useRef(null)
	const buttonRef = useRef(null)

	const ddStyles = {
		width: width ?? rem(maxWidth)
	}

	const ddClass = classname(
		addClass, {
		'dropdown__button': true,
		'dropdown__button--modified': true,
		'dropdown__button--disabled': disabled,
		'dropdown__button--ghost': ghost,
		'dropdown__button--full': full
	})

	useEffect(() => {

		const clickCheckCb = (e) => clickCheck(open, listRef, buttonRef, setOpen, e);

		document.addEventListener('mousedown', clickCheckCb)

		return () => {
			document.removeEventListener('mousedown', clickCheckCb)
		}
	}, [open])

	const setButtonRef = useCallback((node, ref) => {
		buttonRef.current = node
		return ref(node)
	}, [])

	const setListRef = useCallback((node, ref) => {
		listRef.current = node
		return ref(node)
	}, [])

	const onToggle = () => {
		setOpen(!open)
	}

	const onSelect = item => {
		setOpen(false)
		setLabel(item.name)
		return submit(item.value)
	}


	return (
		<Manager>
			<Reference>
				{({ ref }) => (
					<div tabIndex="0"
						className={ddClass}
						style={ddStyles}
						ref={node => setButtonRef(node, ref)}
						onClick={() => onToggle()}
						// onBlur={onFocusOut}
						data-testid={id}
						{...inputProps}
					>
						<div className={((label && label.includes('Select')) || (value && value.includes('Select'))) ? 'dropdown__label' : "dropdown__label__selected"}><MultiClamp clamp={1}>{value || label}</MultiClamp></div>
						<div><IconChevronDown /></div>
					</div>
				)}
			</Reference>
			{open && (
				<Popper
					data-testid="popper"
					placement="bottom"
					modifiers={
						[
							{
								name: 'preventOverflow',
								enabled: true
							},
							{
								name: 'offset',
								options: { offset: [0, 6] }
							}
						]
					}
				>
					{({ ref, style, placement }) => (
						<div ref={node => setListRef(node, ref)} style={{ ...style, ...ddStyles, maxWidth }} data-placement={placement}
							className={`dropdown__list ${(open && "dropdown__list--open") || ""}`}>
							{options.map((item, index) => {
								return (
									<div className={'dropdown__item'} onClick={() => onSelect(item)} key={index}>
										<span title={item.name}>{item.name}</span>
									</div>
								)
							})}
						</div>
					)}
				</Popper>
			)}
		</Manager>
	)
}

export default Dropdown
